// Table of contents //
// 1. layout properties
// 2. colour properties
// 3. z-index

// 1. Layout properties
export enum LabelPosition {
  Top = 'Top',
  Bottom = 'Bottom',
  Left = 'Left',
  Right = 'Right'
}

export enum LabelAlignment {
  Left = 'Left',
  Right = 'Right',
  Center = 'Center'
}

export enum HorizontalLayout {
  Left = 'Left',
  Center = 'Center',
  Right = 'Right',
  SpaceBetween = 'SpaceBetween'
}

export const justifyContents = {
  [HorizontalLayout.Left]: 'flex-start',
  [HorizontalLayout.Center]: 'center',
  [HorizontalLayout.Right]: 'flex-end',
  [HorizontalLayout.SpaceBetween]: 'space-between'
}

export enum VerticalLayout {
  Top = 'Top',
  Center = 'Center',
  Bottom = 'Bottom'
}

export const alignItems = {
  [VerticalLayout.Top]: 'flex-start',
  [VerticalLayout.Center]: 'center',
  [VerticalLayout.Bottom]: 'flex-end'
}

export enum FontWeight {
  //Light = '200',
  Normal = '400',
  Medium = '500',
  SemiBold = '600',
  Bold = '700'
}

export const panelBorderRadius = '6px'

// 2. Colour properties

export const TRANSPARENT = 'transparent'
export const CARD_BORDER = '#dddddd'

// counterparty colours
export const COUNTERPARTY_COLOUR1 = '#066167'
export const COUNTERPARTY_COLOUR2 = '#019fa0'
export const COUNTERPARTY_COLOUR3 = '#99dfdf'

// asset colours
export const ASSET_COLOUR1 = '#6a7020'
export const ASSET_COLOUR2 = '#909520'
export const ASSET_COLOUR3 = '#cdd236'
export const ASSET_COLOUR4 = '#e5e899'

// core colours
export const CORE_PRIMARY = '#ffffff'
export const CORE_PRIMARY_1 = '#f2f2f2'
export const CORE_PRIMARY_2 = '#e6e6e6'
export const CORE_PRIMARY_3 = '#d8d8d8'
export const CORE_PRIMARY_4 = '#a5a5a5'
export const CORE_PRIMARY_5 = '#808080'
export const CORE_PRIMARY_6 = '#404040'
export const CORE_PRIMARY_7 = '#000000'

// accents
export const ACCENT_PRIMARY = '#00afaf'
export const ACCENT_PRIMARY_1 = '#009d9d'
export const ACCENT_PRIMARY_2 = '#33bfbf'
export const ACCENT_PRIMARY_3 = '#b3e7e7'

export const ACCENT_SECONDARY = '#8933bf'
export const ACCENT_SECONDARY_1 = '#7b2eac'
export const ACCENT_SECONDARY_2 = '#a05bcb'

export const ACCENT_GOOD = '#01c38d'
export const ACCENT_GOOD_1 = '#03a077'
export const ACCENT_GOOD_2 = '#33cfa3'
export const ACCENT_GOOD_3 = '#9dffdb'
export const ACCENT_BE_AWARE = '#ff8d00'
export const ACCENT_BE_AWARE_1 = '#e57e00'
export const ACCENT_BE_AWARE_2 = '#ffc57f'
export const ACCENT_BE_AWARE_3 = '#ffe8cc'
export const ACCENT_BAD = '#ff274b'
export const ACCENT_BAD_1 = '#e62343'
export const ACCENT_BAD_2 = '#fca5a5'
export const ACCENT_BAD_3 = '#ffd3d8'

// status colors
export const STATUS_COLOR_DEFAULT = ACCENT_BE_AWARE
export const STATUS_COLOR_INVALID = ACCENT_BAD
export const STATUS_COLOR_UNPREPARED = ACCENT_BE_AWARE
export const STATUS_COLOR_ACTIVE = ACCENT_SECONDARY
export const STATUS_COLOR_STAGING_READY = ACCENT_GOOD
export const STATUS_COLOR_READY = ACCENT_PRIMARY
export const STATUS_COLOR_RESPOND = ACCENT_PRIMARY
export const STATUS_COLOR_EXPIRING = ACCENT_BE_AWARE
export const STATUS_COLOR_URGENT = ACCENT_BAD
export const STATUS_COLOR_ACCEPTED = ACCENT_GOOD
export const STATUS_COLOR_AWAITING = ACCENT_BE_AWARE
export const STATUS_COLOR_DONE = ACCENT_GOOD
export const STATUS_COLOR_INACTIVE = CORE_PRIMARY_4

// direction colors
export const DIRECTION_BUY = '#3e9dff'
export const DIRECTION_SELL = ACCENT_BAD

// 3. z-index
export const zIndexBlotterFloatingTop = 10
export const zIndexBlotterOverlay = 200
export const zIndexDropdownMenu = 300
export const zIndexActivityMonitor = 400
export const zIndexModalOverlay = 500
export const zIndexGrowl = 600
export const zIndexConnectionOverlay = 700
export const zIndexOpenfinTitleBar = 800

// 4. field lengths
export const defaultMaxTextFieldLength = 30
export const bondPriceMaxFieldLength = 12
export const nameMaxFieldLength = 35
export const longNameMaxFieldLength = 100
export const shortIdMaxFieldLength = 10
export const tradingEntityIdMaxFieldLength = 20
export const leiMaxFieldLength = 20
export const bicMaxFieldLength = 11
export const isinMaxFieldLength = 12
export const fisnMaxFieldLength = 35
export const cusipMaxFieldLength = 9
export const emailMaxFieldLength = 75
export const cfiMaxFieldLength = 6
export const collectionNameMaxFieldLength = 50
export const sectorDefaultNoticePeriodFieldLength = 2
export const sectorExDividendDaysFieldLength = 2
export const fxRateFieldLength = 10
export const notesMaxFieldLength = 250
export const internalBookingMaxFieldLength = 200
export const startConsiderationOverrideThresholdFieldLength = 9
export const cmeBasketReferenceFieldLength = 50
export const indexNameMaxFieldLength = 25
export const lagAmountMaxFieldLength = 3
export const ricMaxFieldLength = 50
export const issuerOrganisationIdFieldLength = 15
export const issuerLeiFieldLength = 20

// 5. numerical precision
export const bondPriceMaxFractionDigits = 11

// 6. keywords needed for DOM logic through classes
export const VIRTUALIZATION = 'virtualization'
